export default {
  punch_in: 'Entrée',
  punch_out: 'Sortie',
  breaks_label: 'Pauses',
  no_break: 'Aucune pause',
  total_day_work_time: 'Total du jour',
  planned_travel_time: 'Déplacement prévu',
  total_break: 'Pause totale',
  total_worked: 'Total travaillé',
  data_not_available: 'Données non disponibles',
  weekly_summary: 'Résumé hebdomadaire',
  total_week_work_time: 'Temps de travail total de la semaine',
  total_week_planned_travel: 'Déplacement total prévu de la semaine',
  total_week_break: 'Pause totale de la semaine',
  total_week_worked: 'Total travaillé de la semaine',
  morning_start: 'Début matinée',
  morning_end: 'Fin matinée',
  afternoon_start: 'Début après-midi',
  afternoon_end: 'Fin après-midi',
  expected_hours: 'Heures attendues',
  break_duration: 'Durée de pause',
  notes: 'Notes',
  cancel: 'Annuler',
  save: 'Sauvegarder',
  export_excel: 'Exporter Excel',
  worked_days: 'Jours travaillés',
  non_worked_days: 'Jours de congé',

  // Punch details dialog
  punch_details_for: 'Détails de pointage pour le',
  all_punches_for_day: 'Tous les pointages de cette journée',
  no_punches_today: "Aucun pointage aujourd'hui",
  punch_times_appear_here: 'Les heures de pointage apparaîtront ici une fois créées',
  view_location: "Voir l'emplacement",
  edit_punch: 'Modifier le pointage',
  delete_punch: 'Supprimer le pointage',
  day_summary: 'Résumé de la journée',
  worked: 'Travaillé',
  breaks: 'Pauses',
  travel: 'Déplacement',
  add_punch: 'Ajouter un pointage',

  // Punch types
  break_start: 'Début de pause',
  break_end: 'Fin de pause',

  // Punch editor
  punch_type: 'Type de pointage',
  punch_type_required: 'Le type de pointage est requis',
  punch_date: 'Date de pointage',
  punch_time: 'Heure de pointage',
  punch_date_time: 'Date et heure de pointage',
  time_required: "L'heure est requise",
  invalid_time_format: "Format d'heure invalide (HH:MM)",
  comment: 'Commentaire',
  comment_placeholder: 'Ajouter un commentaire sur ce pointage...',
  location: 'Emplacement',

  // Confirmations
  confirm_delete: 'Confirmer la suppression',
  confirm_delete_punch_message: 'Êtes-vous sûr de vouloir supprimer le pointage {type} à {time}?',

  // Success messages
  punch_updated_successfully: 'Pointage mis à jour avec succès',
  punch_deleted_successfully: 'Pointage supprimé avec succès',
  punch_created_successfully: 'Pointage créé avec succès',
  bulk_operations_completed: 'Opérations groupées complétées avec succès',
  punches_deleted_successfully: 'Pointages supprimés avec succès',
  export_started: 'Exportation démarrée',

  // Error messages
  error_updating_punch: 'Erreur lors de la mise à jour du pointage',
  error_deleting_punch: 'Erreur lors de la suppression du pointage',
  error_creating_punch: 'Erreur lors de la création du pointage',
  error_bulk_operations: 'Erreur lors des opérations groupées',
  error_deleting_punches: 'Erreur lors de la suppression des pointages',
  error_loading_activity: "Erreur lors du chargement de l'activité",
  error_exporting: "Erreur lors de l'exportation des données",

  // Features
  location_feature_coming_soon: "La fonctionnalité de visualisation de l'emplacement arrive bientôt",
}
